import Spacings from '@dynatrace/strato-design-tokens/spacings';

import {
  ThresholdType,
  RequiredPieChartConfiguration,
  PieChartLegendConfig,
} from './pie-chart.config.js';
import { DEFAULT_TRUNCATION_MODE, defaultRatio } from '../../core/constants.js';

export const DEFAULT_CONTAINER_PADDING = Spacings.Size6;
export const DEFAULT_SIZE = 300;
export const DONUT_INTERNAL_RADIUS = 0.75;
export const PIE_INTERNAL_RADIUS = 1;
export const LABEL_FONT_SIZE = 12;
export const SHOW_LABEL_RELATIVE_VALUE_THRESHOLD = 20;
export const SHOW_LABEL_SLICES_THRESHOLD = 2;
export const LABEL_FONT_SIZE_MULTIPLIER = 1.5;
export const DEFAULT_LEGEND: PieChartLegendConfig = {
  position: 'auto',
  hidden: false,
  ratio: defaultRatio,
};
export const DEFAULT_TOOLTIP_MARGIN = 40;

export const defaultConfig: RequiredPieChartConfiguration = {
  height: DEFAULT_SIZE,
  colorPalette: 'categorical',
  labels: { hidden: false, valueType: 'relative' },
  grouping: { threshold: { type: 'relative', value: 2 } },
  legend: DEFAULT_LEGEND,
  formatter: () => '',
  truncationMode: DEFAULT_TRUNCATION_MODE,
};

export const zIndicesPieAreas = {
  toolbar: 2,
  overlay: 1,
};

export const THRESHOLD_TYPE: Record<string, ThresholdType> = {
  ABSOLUTE: 'absolute',
  RELATIVE: 'relative',
  NUMBER_OF_SLICES: 'number-of-slices',
};

export const PIE_CATEGORICAL_LEGEND_SIZES = {
  minWidth: 0.1,
  minHeight: 0.1,
  maxWidth: 0.8,
  maxHeight: 0.7,
};

export const LABEL_TEXT_POSITION = {
  END: 'end',
  START: 'start',
};
